// extracted by mini-css-extract-plugin
module.exports = {"form":"zUww6epsu3CTe4vrz_Y_T","save":"_2PSrKxaMPH90WM3pM9QEJ5"};